import * as ScreenIntro from './ScreenIntro';
import * as ScreenAnatomy from './ScreenAnatomy';
import * as ScreenMovements from './ScreenMovements';
import * as ScreenMethod from './ScreenMethod';
import * as ScreenSqueezeTips from './ScreenSqueezeTips';
import * as ScreenSqueezeNotes from './ScreenSqueezeNotes';
import * as ScreenPushSteps from './ScreenPushSteps';
import * as ScreenPushNotes from './ScreenPushNotes';
import * as ScreenCorrect from './ScreenCorrect';

// Active screen IDs mapped to their per-screen modules. IDs stay
// stable across the migration so the orchestrator's post-tryout
// setCurrentScreen(10) / setCurrentScreen(12) etc. still resolves
// the right screen. ACTIVE_SCREENS keeps the visit order.
export const SCREENS = {
  0: ScreenIntro,
  1: ScreenAnatomy,
  3: ScreenMovements,
  4: ScreenMethod,
  8: ScreenSqueezeTips,
  9: ScreenSqueezeNotes,
  10: ScreenPushSteps,
  11: ScreenPushNotes,
  12: ScreenCorrect,
};

export const ACTIVE_SCREENS = [0, 1, 3, 4, 8, 9, 10, 11, 12];
